/** PRD §7 page_key 注册表（spec 真源，此处为 fallback） */
export const PAGE_KEYS = {
  HOME: "home",
  LOGIN_MAIN: "login_main",
  REGISTER_MAIN: "register_main",
  WALLET: "wallet",
  DEPOSIT_FIAT: "deposit_fiat",
  DEPOSIT_CRYPTO: "deposit_crypto",
  WITHDRAW_FIAT: "withdraw_fiat",
  WITHDRAW_CRYPTO: "withdraw_crypto",
  KYC_MAIN: "kyc_main",
  AICOPY_LIST: "aicopy_list",
  AICOPY_SIGNAL: "aicopy_signal",
  CFD_TRADE: "cfd_trade",
  SPIN_MAIN: "spin_main",
  COUPON_CENTER: "coupon_center",
};

/** PRD §5 常用 entry 枚举 */
export const ENTRIES = {
  HOME: "home",
  BANNER: "banner",
  LOGIN_PAGE: "login_page",
  DEEPLINK: "deeplink",
  INVITE: "invite",
  SPIN_WHEEL: "spin_wheel",
  HOME_DEPOSIT: "home_deposit",
  WALLET: "wallet",
  MORE: "more",
  ASSET_DETAIL: "asset_detail",
};

export default PAGE_KEYS;
